import {BASE_ELEMENT_IDS as BASE_ELEMENT_IDS} from "../../BaseDOM";
import SystemConfig, {CONFIG_PARAMS} from "../../../system/SystemConfig";
import {translate} from "../../../translations/translations";

export default function createInfoBoxes(parent: HTMLElement, gameName: string, config: SystemConfig) {

    let reg = config.get(CONFIG_PARAMS.REGULATION);
    let warning = config.get(CONFIG_PARAMS.WARNING_MESSAGE);
    let lang = config.get(CONFIG_PARAMS.LANGUAGE);

    let container = document.createElement("div");
    container.id = BASE_ELEMENT_IDS.INFO_BOX_CONTAINER;
    container.classList.add("info-box-container", "mx-grey-text");
    parent.appendChild(container);

    if (reg && warning) {
        container.innerText = gameName + ", " + translate("text_warning", lang);
    } else if (reg) {
        container.innerText = gameName;
    } else if (warning) {
        container.innerText = translate("text_warning", lang);
    } else {
        $(container).hide();
    }

    let balanceBox = document.createElement("div");
    balanceBox.id = BASE_ELEMENT_IDS.INFO_BOX_BALANCE;
    balanceBox.classList.add("info-box", "info-box-balance", "mx-grey-text");
    parent.appendChild(balanceBox);
    $(balanceBox).hide();

    let balanceBoxImage = document.createElement("span");
    balanceBoxImage.classList.add("info-box-balance-image");
    balanceBoxImage.id = BASE_ELEMENT_IDS.INFO_BOX_BALANCE_IMAGE;
    balanceBox.appendChild(balanceBoxImage);

    let balanceBoxText = document.createElement("span");
    balanceBoxText.classList.add("info-box-balance-text");
    balanceBoxText.id = BASE_ELEMENT_IDS.INFO_BOX_BALANCE_VALUE;
    // balanceBoxText.innerHTML = "";
    balanceBox.appendChild(balanceBoxText);
}